// Conditionally import OneSignal for native platforms only
import * as oneSignalStub from '~services/web/oneSignalStub';
import { Platform } from 'react-native';
let OneSignal: any = null;
if (Platform.OS !== 'web') {
  OneSignal = require('react-native-onesignal').default;
} else {
  OneSignal = oneSignalStub.OneSignal;
}
import {useOnboardingStore} from '~providers/onboarding/zustand';
import {useUserStore} from '~providers/userStore/zustand';
import {useEnhancedAuth} from '~hooks/auth/useEnhancedAuth';

export const useHandleLogOut = () => {
  const {reset} = useOnboardingStore();
  const {resetUser} = useUserStore();
  const {logout} = useEnhancedAuth();

  const handleLogOut = async () => {
    reset();
    try {
      // Use OneSignal v4 API for disabling push notifications (skip on web)
      if (Platform.OS !== 'web') {
        OneSignal.disablePush(true);
        console.log('✅ OneSignal push notifications disabled');
      }
    } catch (error) {
      console.error('❌ Failed to opt out OneSignal push subscription:', error);
    }
    await logout();
  };

  return {handleLogOut};
};
